import { Box, Grid, GridItem, HStack, VStack, Text, Divider } from "@chakra-ui/react";
import { DataTable, StatusBadge, CurrencyText, BrandLogo } from "../../../shared/ui";
import { rotuloTipoVinculo } from "../../vinculos/api/vinculosApi";

const COLUNAS = [
  { key: "data", label: "Data" },
  { key: "descricao", label: "Descrição" },
  { key: "valor", label: "Valor", align: "right", render: (row) => <CurrencyText value={row.valor} /> },
  { key: "previsao", label: "Previsão" },
  { key: "status", label: "Situação", render: (row) => <StatusBadge status={row.status} /> },
];

function BlocoParte({ titulo, children }) {
  return (
    <VStack align="flex-start" spacing={1}>
      <Text fontSize="xs" fontWeight="semibold" color="app-muted-fg" textTransform="uppercase" letterSpacing="wider">
        {titulo}
      </Text>
      {children}
    </VStack>
  );
}

// Renderização visual do documento de comprovação — espelha o conteúdo do PDF gerado
// pelo backend (o snapshot é a mesma fonte de dados para ambos).
export default function ComprovacaoDocument({ documento }) {
  return (
    <Box bg="app-card" border="1px solid" borderColor="app-border" borderRadius="xl" p={{ base: 5, md: 8 }}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <BrandLogo h="28px" />
          <Text fontSize="sm" color="app-muted-fg" mt={1}>
            Demonstrativo de plantões / Comprovação de valores a receber
          </Text>
        </Box>

        <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={6}>
          <GridItem>
            <BlocoParte titulo="Prestador">
              <Text fontWeight="semibold">{documento.prestador.nome_completo}</Text>
              <Text fontSize="sm" color="app-muted-fg">
                {[documento.prestador.especialidade, documento.prestador.crm].filter(Boolean).join(" · ")}
              </Text>
              <Text fontSize="sm" color="app-muted-fg">
                {[documento.prestador.razao_social_pj, documento.prestador.cnpj_pj && `CNPJ ${documento.prestador.cnpj_pj}`]
                  .filter(Boolean)
                  .join(" · ")}
              </Text>
            </BlocoParte>
          </GridItem>
          <GridItem>
            <BlocoParte titulo="Tomador">
              <Text fontWeight="semibold">{documento.tomador.nome}</Text>
              <Text fontSize="sm" color="app-muted-fg">
                {[rotuloTipoVinculo(documento.tomador.tipo), documento.tomador.cnpj && `CNPJ ${documento.tomador.cnpj}`]
                  .filter(Boolean)
                  .join(" · ")}
              </Text>
              <Text fontSize="sm" color="app-muted-fg">
                Período: {documento.periodo.rotulo}
              </Text>
            </BlocoParte>
          </GridItem>
        </Grid>

        <DataTable columns={COLUNAS} rows={documento.plantoes ?? []} isLoading={false} />

        <Divider />

        <VStack align="stretch" spacing={2}>
          <HStack justify="space-between">
            <Text fontWeight="semibold">Total do período</Text>
            <Text fontWeight="bold">
              <CurrencyText value={documento.total_periodo} />
            </Text>
          </HStack>
          <HStack justify="space-between" color="accent-text">
            <Text fontWeight="semibold">Em aberto (a receber)</Text>
            <Text fontWeight="bold">
              <CurrencyText value={documento.total_em_aberto} />
            </Text>
          </HStack>
        </VStack>

        <Box>
          <Text fontSize="xs" color="app-muted-fg">
            {documento.nota_juridica}
          </Text>
          <Text fontSize="xs" color="app-muted-fg" textAlign="right" mt={2}>
            Emitido em {documento.gerado_em}
          </Text>
        </Box>
      </VStack>
    </Box>
  );
}
